/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MyProfileUpdate interface.
 */
export function instanceOfMyProfileUpdate(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('receivesEmails' in value) || value['receivesEmails'] === undefined)
        return false;
    if (!('receivesPush' in value) || value['receivesPush'] === undefined)
        return false;
    return true;
}
export function MyProfileUpdateFromJSON(json) {
    return MyProfileUpdateFromJSONTyped(json, false);
}
export function MyProfileUpdateFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'pictureKey': json['picture_key'] == null ? undefined : json['picture_key'],
        'receivesEmails': json['receives_emails'],
        'receivesPush': json['receives_push'],
    };
}
export function MyProfileUpdateToJSON(json) {
    return MyProfileUpdateToJSONTyped(json, false);
}
export function MyProfileUpdateToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'picture_key': value['pictureKey'],
        'receives_emails': value['receivesEmails'],
        'receives_push': value['receivesPush'],
    };
}
